import { getTodayTradeChart, addDaPing, putDaPing, delDaPing, getDaPing, getWeekOrdSumChart, getTodayOrdSumChart, getTodayCaipin, getMerchantsreen } from '@/api/chart'

const state = {}
const mutations = {}

const actions = {
	addDaPing ({}, data) {
		return new Promise((resolve, reject) => {
			addDaPing(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	putDaPing ({}, data) {
		return new Promise((resolve, reject) => {
			putDaPing(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	delDaPing ({}, data) {
		return new Promise((resolve, reject) => {
			delDaPing(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getDaPing ({}, data) {
		return new Promise((resolve, reject) => {
			getDaPing(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getTodayTradeChart ({}, data) {
		return new Promise((resolve, reject) => {
			getTodayTradeChart(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getWeekOrdSumChart ({}, data) {
		return new Promise((resolve, reject) => {
			getWeekOrdSumChart(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getTodayOrdSumChart ({}, data) {
		return new Promise((resolve, reject) => {
			getTodayOrdSumChart(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getTodayCaipin ({}, data) {
		return new Promise((resolve, reject) => {
			getTodayCaipin(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getMerchantsreen ({}, data) {
		return new Promise((resolve, reject) => {
			getMerchantsreen(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
